<template>
	<el-form-item label="占位内容">
		<el-input v-model="data.options.placeholder" />
	</el-form-item>

	<el-form-item label="是否可搜索">
		<el-switch v-model="data.options.filterable" />
	</el-form-item>

	<el-form-item label="是否多选">
		<el-switch v-model="data.options.multiple" @change="handleMultiple" />
	</el-form-item>

	<el-form-item label="可选任意节点">
		<el-switch v-model="data.options.checkStrictly" />
	</el-form-item>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from 'vue'

export default defineComponent({
	name: 'ItemTreeSelect',
	props: {
		active: {
			type: Object,
			default: null
		}
	},
	emits: ['update:active'],
	setup(props, context) {
		const data = ref(props.active)
		watch(data, val => context.emit('update:active', val), { deep: true })

		const handleMultiple = () => {
			if (data.value.options.multiple) {
				data.value.options.defaultValue = []
			} else {
				data.value.options.defaultValue = ''
			}
		}

		return {
			data,
			handleMultiple
		}
	}
})
</script>
